import React, { useState, useEffect } from "react";
import { Layout, Button, Typography, Row, Col } from 'antd';
import myFriendText from "../../assets/images/my_friend_text.svg";
import goBackButton from "../../assets/images/Go_Back.svg";
import searchButton from "../../assets/images/Search Icon.svg";
import "../onboarding/UserOnboardingPage.css";
import { useNavigate } from "react-router-dom";
import welcomeText from "../../assets/images/Ellipse 35.svg";
import logo from "../../assets/images/my-friend-logo.png";
import helpInstruction from "../../assets/images/help-instruction.png"
import { getScriptStatus } from "../../api/password";  
import { isNull } from "lodash";  
import "./HelpPageStyle.css";

function HelpPage() {
  const [gettingToKnowScriptStatus, setGettingToKnowScriptStatus] = useState(false);
  const [responseLoading, setResponseLoading] = useState(true);
  const navigate = useNavigate();

  const { Content } = Layout;
  const { Text } = Typography;

  useEffect(() => {
    checkGettingToKnowYouScriptStatus();
  }, []);

  const checkGettingToKnowYouScriptStatus = async () => {
    try {
      const response = await getScriptStatus();
      if (!isNull(response.conversation)) {
        response?.conversationCompleted && setGettingToKnowScriptStatus(true);
        setResponseLoading(true);
      } else {
        setGettingToKnowScriptStatus(false);
        setResponseLoading(true);
      }
    } catch (err) {
      console.log("In catch", err);
    }
  }; 

  const handleConversationButtonClick = () => {
    gettingToKnowScriptStatus
      ? navigate("/conversation?type=openConversation")
      : navigate("/conversation?type=gettingToKnowYou");
  };


  return (
    <>
      <div>
        <Row className="onboarding-page-section">
          <Col flex="10%" className="go-back-button">
            <button onClick={handleConversationButtonClick} className="button-styling">
              <img src={goBackButton} alt="Go Back Button" />
            </button>
          </Col>
          <Col flex="80%" className="my-friend-text">
            <img src={myFriendText} alt="My Friend Text" />
          </Col>
          <Col flex="10%" className="search-button">
            <button className="button-styling">
              <img src={searchButton} alt="Search Button" />
            </button>
          </Col>
        </Row>
      <Content className="content">
      <Row justify="center" align="middle" className="">
        <Col xs={24} md={12} className="image-col">
          <div className="image-container right-side-style">
            <div className="img-relative">
            <img src={welcomeText} alt="Welcome Text" className="img-styling " />
            <p className="text-style">
                    Talk to me!
                  </p>
            </div>
            <img src={logo}  alt="Talk to me!" className="main-image" />
          </div>
        </Col>
        <Col xs={24} md={12} className="text-col">
          <Text className="description">
            <span className="text-heading-style">Hello!</span> <br />
            <div className="text-para-style">
              I’m Amy/Arthur, your friendly online assistant. I am designed to help with anything and everything you could think of.
              But remember, I am AI and cannot give you personal opinions of my own. If you get click on the question mark in the top
              right corner for suggestions.
            </div>
          </Text>
           <img src={helpInstruction}  alt="Talk to me!" className="main-image" />
        
          <Button onClick={handleConversationButtonClick} type="primary" className="start-button btn-styling">Let’s Start</Button> 
        </Col>
      </Row>
    </Content>
      </div>
    </>
  );
}

export default HelpPage;